import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const BoxFlex = styled(Box)(
    ({ theme }: ParamsStyle) => `
    display: flex;
    gap: 1.25rem;
    display: flex;
    justify-content: space-between;
    
    .MuiSelect-select.MuiSelect-outlined.MuiOutlinedInput-input.MuiInputBase-input {
        max-width: 11.5rem !important;
    }

   @media(min-width: ${theme?.breakpoints.values.md}px) { 
   }
`);